import { PageTitle, Table, useList } from "@/pages/admin/ui";
import { useState } from "react";

const CAT_COLORS = {
  Auth: "bg-slate-100 text-slate-700", Enquiry: "bg-blue-50 text-blue-700", Menu: "bg-amber-50 text-amber-700",
  Packages: "bg-orange-50 text-orange-700", Gallery: "bg-pink-50 text-pink-700", Brand: "bg-indigo-50 text-indigo-700",
  Branch: "bg-indigo-50 text-indigo-700", Staff: "bg-teal-50 text-teal-700", CCTV: "bg-gray-100 text-gray-700",
  Settings: "bg-purple-50 text-purple-700", Events: "bg-green-50 text-green-700", Bulk: "bg-green-50 text-green-700",
  Upload: "bg-cyan-50 text-cyan-700", Users: "bg-rose-50 text-rose-700",
};

function fmt(ts) {
  if (!ts) return "—";
  try { return new Date(ts).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); }
  catch { return ts.slice(0, 16).replace("T", " "); }
}

export default function AdminActivity() {
  const { data, loading, reload } = useList("/admin/activity", []);
  const [filter, setFilter] = useState("All");
  const cats = ["All", ...Array.from(new Set(data.map((d) => d.category).filter(Boolean)))];
  const rows = data.filter((d) => filter === "All" || d.category === filter);

  return (
    <div data-testid="admin-activity">
      <PageTitle title="Activity Log" subtitle="A detailed record of everything happening across the website and admin portal." right={<button className="text-sm text-[#C5A059] hover:underline" onClick={reload}>Refresh</button>} />
      <div className="mb-5 flex flex-wrap gap-2">
        {cats.map((c) => (
          <button key={c} onClick={() => setFilter(c)} data-testid={`activity-filter-${c.toLowerCase()}`}
            className={`rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${filter === c ? "bg-[#2C201A] text-white" : "border border-[#E2E8F0] text-[#64748B] hover:bg-white"}`}>
            {c}
          </button>
        ))}
      </div>
      {loading ? <div className="text-sm text-[#64748B]">Loading…</div> : (
        <Table headers={["When", "Who", "Role", "Category", "Activity"]}>
          {rows.map((r) => (
            <tr key={r.id} className="hover:bg-[#F8F9FA]">
              <td className="whitespace-nowrap px-4 py-3 text-xs text-[#64748B]">{fmt(r.created_at)}</td>
              <td className="px-4 py-3 font-medium text-[#0F172A]">{r.actor}</td>
              <td className="px-4 py-3 text-xs capitalize text-[#64748B]">{(r.role || "").replace(/_/g, " ") || "—"}</td>
              <td className="px-4 py-3"><span className={`rounded-full px-2.5 py-1 text-[11px] font-semibold ${CAT_COLORS[r.category] || "bg-gray-100 text-gray-600"}`}>{r.category}</span></td>
              <td className="px-4 py-3 text-[#334155]">{r.description}</td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={5} className="px-4 py-10 text-center text-[#94A3B8]">No activity recorded yet.</td></tr>}
        </Table>
      )}
    </div>
  );
}
